interface HelioLogoProps {
  className: string;

}
const HelioLogo = ({ className }: HelioLogoProps) => {
  return <svg xmlns="http://www.w3.org/2000/svg" width="72" height="25.2" viewBox="0 0 68.628 24">
    <g className={className} data-name="Helio Logo" transform="translate(0)">
      <path data-name="Helio Logo" d="M0,11.772V23.621H3.9V14.158A5.592,5.592,0,0,1,0,11.772ZM26.666,7.745a8.127,8.127,0,1,0,7.217,11.912h-4.3a4.564,4.564,0,0,1-2.9.968,4.356,4.356,0,0,1-4.313-3.059H34.609a8.229,8.229,0,0,0,.179-1.7A8.127,8.127,0,0,0,26.666,7.745ZM22.31,14.318a4.356,4.356,0,0,1,4.356-3.209,4.356,4.356,0,0,1,4.356,3.209Zm23.486,9.3h3.9V8.156H45.8ZM60.505,7.745a8.127,8.127,0,1,0,8.122,8.125,8.127,8.127,0,0,0-8.122-8.125Zm0,12.885a4.47,4.47,0,0,1-4.565-4.758,4.571,4.571,0,1,1,9.134.024,4.48,4.48,0,0,1-4.569,4.753ZM47.746,1.689a2.28,2.28,0,1,0,2.275,2.275A2.28,2.28,0,0,0,47.746,1.689ZM37.794,23.621h3.9V0h-3.9ZM9.507,7.933,6.539,7.566A3.016,3.016,0,0,1,3.9,4.579V0H0V5.136a6.293,6.293,0,0,0,5.528,6.259L8.8,11.8a3.262,3.262,0,0,1,2.866,3.243v8.577h3.9V14.8a6.917,6.917,0,0,0-6.06-6.864Z"/>
    </g>
  </svg>
};

export default HelioLogo;
